module.exports = __webpack_public_path__ + "img/qinghai.d7dce46c.png";